export default "__VITE_ASSET__DSvRpXlU__"